import moment from "moment";
import { DatePicker, Box } from "orcs-design-system";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import getInputLabel from "src/util/getInputLabel";
import useWorkspaceDateFormats from "src/hooks/useWorkspaceDateFormats";

const TagAttributeDateInput = ({
  id,
  name,
  onDateChange,
  value,
  label,
  displayFormat,
  placeholder,
  invalid,
  mandatory,
  focus,
}) => {
  const { short: defaultDateFormat } = useWorkspaceDateFormats();
  const resolvedDisplayFormat = displayFormat || defaultDateFormat;
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (focus) {
      setFocused(true);
    }
  }, [focus]);

  // Use displayFormat for parsing/formatting (maintains compatibility)
  const parseFormat = resolvedDisplayFormat;

  const handleDateChange = (selectedDate) => {
    onDateChange(selectedDate && selectedDate.format(parseFormat));
  };

  return (
    <Box>
      <DatePicker
        single
        id={id}
        name={name}
        date={value && moment(value, parseFormat)}
        focused={focused}
        placeholder={placeholder}
        onDateChange={handleDateChange}
        onFocusChange={(el) => {
          setFocused(el.focused);
        }}
        label={getInputLabel(label, invalid)}
        invalid={invalid}
        required={mandatory}
        numberOfMonths={1}
        daySize={31}
        displayFormat={resolvedDisplayFormat}
        readOnly
        width="100%"
        zIndex="12"
      />
    </Box>
  );
};

TagAttributeDateInput.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  displayFormat: PropTypes.string,
  placeholder: PropTypes.string,
  onDateChange: PropTypes.func,
  invalid: PropTypes.bool,
  mandatory: PropTypes.bool,
  focus: PropTypes.bool,
};

export default TagAttributeDateInput;
